import { render, staticRenderFns } from "./hotGame.vue?vue&type=template&id=693a8a69&scoped=true"
import script from "./hotGame.vue?vue&type=script&lang=js"
export * from "./hotGame.vue?vue&type=script&lang=js"
import style0 from "./hotGame.vue?vue&type=style&index=0&id=693a8a69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693a8a69",
  null
  
)

export default component.exports